module.exports = __webpack_public_path__ + "img/patient-medical.7d327d9d.svg";